import { Button } from "../../../../components";
import { Text, VStack, Stack } from "native-base";
import Spinner from "react-native-loading-spinner-overlay";
import { useAuthContext, useSupplierContext } from "../../../../contexts";
import { Modal, Pressable, StyleSheet, View } from "react-native";
import { ParamListBase, RouteProp, useFocusEffect } from "@react-navigation/native";
import { useCallback, useState } from "react";
import moment from "moment";
import { DisinvestmentList } from "../DisinvestmentList";
import { getDivestmentList } from "../../../../services/divestimentService";
import { SearchDisinvestment } from "../SearchDisinvestment";
import { postDivestimentHeader } from "../../../../services/divestimentService";
import { DrawerNavigationProp } from "@react-navigation/drawer";
import { ModalAlert } from "../../../../components/ModalAlert";

export interface IDisinvestmentItem {
  creation_date: string;
  status: string;
  qty: number;
  id: string;
  disinvestment_order_header_status_id: number;
}

export const Disinvestment = ({ route, navigation }: { route: RouteProp<ParamListBase, string>; navigation: DrawerNavigationProp<ParamListBase> }) => {
  const { currentSupplier } = useSupplierContext();
  const [disinvestmentListData, setDisinvestmentListData] = useState<IDisinvestmentItem[]>([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(15);
  const [lastOrder, setLastOrder] = useState<IDisinvestmentItem | null>(null);
  const [searchStatus, setSearchStatus] = useState<string>();
  const [searchInitialDate, setSearchInitialDate] = useState<string>();
  const [searchFinalDate, setSearchFinalDate] = useState<string>();
  const [showAlert, setShowAlert] = useState(false);

  const handleCloseAlert = () => {
    setShowAlert(false);
    navigation.navigate("HomeScreen");
  };

  // useFocusEffect(
  //   useCallback(() => {
  //     loadApi();
  //   }, [currentSupplier, searchStatus, searchInitialDate, searchFinalDate, route])
  // );

  useFocusEffect(
    useCallback(() => {

      const getDisivestmentList = async () => {
        try {
          loadApi();
        } catch (error) {
          console.error(error);
        } finally {
          setIsLoading(false);
        }
      };
      getDisivestmentList();

      return () => {
        setDisinvestmentListData([]);
        setOffset(0);
      };

    }, [currentSupplier, searchStatus, searchInitialDate, searchFinalDate, route])
  );

  async function getDisinvestmentList(id: number, searchStatus: string, searchInitialDate: string, searchFinalDate: string, offset: number, limit: number) {
    try {
      const disinvestmentList = await getDivestmentList(id, searchStatus, searchInitialDate, searchFinalDate, offset, limit);
      if (disinvestmentList?.status) {
        return disinvestmentList.result;
      } else {
        return [];
      }
    } catch (error: any) {
      console.error(error);
      if (error.response && error.response.status === 400 && !currentSupplier) {
        setShowAlert(true);
      }
      return [];
    }
  }

  async function loadApi() {
    if (isLoading) return;
    setIsLoading(true);
    const response = await getDisinvestmentList(currentSupplier, searchStatus, searchInitialDate, searchFinalDate, offset, limit);
    if (disinvestmentListData) {
      setDisinvestmentListData([...disinvestmentListData, ...response]);
    }

    if (response.length > 0) {
      setOffset(offset + limit);
    }

    setIsLoading(false);
  }

  function handleSearch(
    status?: string,
    initialDate?: string,
    finalDate?: string
  ) {
    let iDate;
    let fDate;

    if (initialDate) {
      iDate = moment(initialDate, "DD-MM-YYYY").format("YYYY-MM-DD");
    }
    if (finalDate) {
      fDate = moment(finalDate, "DD-MM-YYYY").format("YYYY-MM-DD");
    }

    if (status === "0") {
      setSearchStatus(undefined);
    } else {
      setSearchStatus(status);
    }
    setSearchInitialDate(iDate);
    setSearchFinalDate(fDate);
    setOffset(0);
    setDisinvestmentListData([]);
  }

  function handleItemSelect(headerId: string) {
    navigation.navigate("DisinvestmentItemListScreen", { headerId: headerId });
  }

  function handleRequestDivestiment() {
    const lastOrderWithStatusOne = disinvestmentListData?.reduce<IDisinvestmentItem | null>((prevOrder, currOrder) => {

      if (
        currOrder.disinvestment_order_header_status_id === 1 &&
        (!prevOrder || currOrder.creation_date > prevOrder.creation_date)
      ) {
        return currOrder;
      }
      return prevOrder;
    }, null);

    if (lastOrderWithStatusOne) {
      setModalVisible(true);
      setLastOrder(lastOrderWithStatusOne);
    } else {
      createDisinvestment();
    }
  }

  async function createDisinvestment() {
    setModalVisible(false);
    if (currentSupplier) {
      const data = await postDivestimentHeader(currentSupplier);
      if (data?.status) {
        const headerId = data.result.disinvestmentHeaderId;
        navigation.navigate("DisinvestmentItemListScreen", {
          headerId: headerId,
        });
      }
    }
  }

  return (
    <>
      <VStack flex={1} _web={{ px: 20, w: "100%" }} bg="#fff">
        <SearchDisinvestment handleSearch={handleSearch} />

        <DisinvestmentList
          disinvestmentListData={disinvestmentListData}
          handleItemSelect={handleItemSelect}
          onEndReached={loadApi}
          onEndReachedThreshold={0.1}
          isLoading={isLoading}
        />

        <Stack px={10} py={2}>
          <Button
            isDisabled={
              !(disinvestmentListData && disinvestmentListData.length > 0)
            }
            label="SOLICITAR DESINVESTIMENTO"
            onPress={() => handleRequestDivestiment()}
          />
        </Stack>
      </VStack>

      <Modal
        animationType="slide"
        transparent={true}
        visible={modalVisible}
        onRequestClose={() => {
          setModalVisible(!modalVisible);
        }}
      >
        <View style={styles.centeredView}>
          <View style={styles.modalView}>
            <Text style={styles.modalText}>Já existe uma solicitação</Text>
            <Text style={styles.modalText}>"EM PREENCHIMENTO".</Text>
            <Text style={styles.modalText}>Deseja criar uma nova?</Text>
            <View style={styles.buttons}>
              <Pressable
                style={[styles.button, styles.buttonClose]}
                onPress={() => {
                  setModalVisible(false);
                  if (lastOrder) {
                    navigation.navigate("DisinvestmentItemListScreen", {
                      headerId: lastOrder.id,
                    });

                  }
                }
                }
              >
                <Text style={styles.textStyle}>Manter Atual</Text>
              </Pressable>
              <Pressable
                style={[styles.button, styles.buttonClose]}
                onPress={() => createDisinvestment()}
              >
                <Text style={styles.textStyle}>Criar Nova</Text>
              </Pressable>
            </View>
          </View>
        </View>
      </Modal>

      <ModalAlert isVisible={showAlert} onClose={handleCloseAlert} />

      <Spinner visible={isLoading} />
    </>
  );
};

const styles = StyleSheet.create({
  centeredView: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    marginTop: 22,
  },
  modalView: {
    margin: 20,
    backgroundColor: "white",
    borderRadius: 20,
    padding: 35,
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  button: {
    borderRadius: 20,
    paddingLeft: 20,
    paddingRight: 20,
    padding: 10,
    elevation: 2,
    marginLeft: 10,
    marginRight: 10,
  },
  buttonOpen: {
    backgroundColor: "#F194FF",
  },
  buttonClose: {
    backgroundColor: "#2196F3",
  },
  textStyle: {
    color: "white",
    fontWeight: "bold",
    textAlign: "center",
  },
  modalText: {
    marginBottom: 10,
    textAlign: "center",
  },
  buttons: {
    display: "flex",
    flexDirection: "row",
  },
});
